import React, { FC, useCallback, useState } from 'react'

import { VerticalCarousel } from 'shared/components'
import { VideoSliderItem } from './VideoSliderItem/VideoSliderItem'
import { useScrollPosition } from '@n8tb1t/use-scroll-position'

import classNames from 'classnames'
import classes from './VideoSlider.module.scss'

export type VideoSlider = {
  slides: VideoSliderItem[]
  onlyVideo?: boolean
  loop?: boolean
}

export const VideoSlider: FC<VideoSlider> = ({
  onlyVideo = false,
  slides,
  loop = false,
}: VideoSlider) => {
  const [activeSlide, setActiveSlide] = useState(0)
  const [isAnimated, setAnimated] = useState(false)

  function selectNextSlide(currIdx: number, arrLength: number) {
    if (currIdx !== undefined && arrLength !== undefined) {
      const nextSlideIdx = currIdx + 1 <= arrLength - 1 ? currIdx + 1 : 0
      setActiveSlide(nextSlideIdx)
    }
  }

  const renderItems = useCallback(
    () =>
      slides.map((item, itemIndex, items) => (
        <VideoSliderItem
          key={itemIndex}
          {...slides[itemIndex]}
          isActive={itemIndex === activeSlide}
          onlyVideo={onlyVideo}
          loop={loop}
          selectNextSlide={() => selectNextSlide(itemIndex, items.length)}
        />
      )),
    [slides, activeSlide, onlyVideo, loop]
  )

  const [mouseHidden, setHideOnScroll] = useState(false)
  useScrollPosition(
    ({ currPos }) => {
      const hidden = currPos.y > 100
      if (hidden !== mouseHidden) {
        setHideOnScroll(hidden)
      }
    },
    [mouseHidden, setHideOnScroll],
    undefined,
    true,
    200
  )
  const mouseContainerClassName = classNames(classes.mouse_container, {
    [classes.hidden]: mouseHidden,
  })

  return (
    <div className={classes.container}>
      {!onlyVideo && (
        <VerticalCarousel
          activeSlideIdx={activeSlide}
          sliderItems={slides}
          onChange={v => {
            !isAnimated && activeSlide !== v && setAnimated(true)
            setActiveSlide(v)
          }}
          isFull
        />
      )}
      {renderItems()}
      {!onlyVideo && (
        <div className={mouseContainerClassName}>
          <div className={classes.mouse_icon}>
            <span className={classes.mouse_wheel} />
          </div>
        </div>
      )}
    </div>
  )
}
